<template>
    <div>
        <van-form ref="form" @submit="doRegister">
            <van-field
                v-model="form.account"
                name="账号"
                label="账号"
                placeholder="请输入账号"
                :rules="rules.account"
            />
            <van-field
                v-model="form.phone"
                name="手机号"
                label="手机号"
                placeholder="请输入手机号"
                :rules="rules.phone"
            />
            <!-- 短信验证码 -->
            <sms-code :form="form"/>

            <van-field
                v-model="form.nickname"
                name="昵称"
                label="昵称"
                placeholder="请输入昵称"
                :rules="rules.nickname"
            />

            <van-field
                v-model="form.password"
                type="password"
                name="密码"
                label="密码"
                placeholder="请输入密码"
                :rules="rules.password"
            />

            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import md5 from 'blueimp-md5';
import {doRegister} from "@/api/CommonApi";
import {Toast} from "vant";
import SmsCode from "@/views/my/login/sms-code";

export default {
    name: "register",
    components: {SmsCode},
    data(){
        return {
            form: {
                account: '',
                phone: '',
                nickname: '',
                password: '',
                code: '',
            },
            hsId: false,
            hsPhone: false,
            hsNickname: false,
            hsPwd: false,
            hsCheckPwd: false,
            rules: {
                account: [
                    {require: true, trigger: 'blur',message:'请输入账号'},
                    {
                        pattern:/^[a-zA-Z]\w{5,15}$/,
                        trigger: 'blur',
                        message: '账号需要大于6位小于16位且以字母开头'
                    }
                ],
                phone: [
                    {require: true, trigger: 'blur',message:'请输入手机号'},
                    {
                        pattern:/^1[3456789]\d{9}$/,
                        trigger: 'blur',
                        message: '请输入正确的手机号码'
                    }
                ],
                nickname: [
                    {require: true, trigger: 'blur',message:'请输入昵称'},
                ],
                password: [
                    {require: true, trigger: 'blur',message:'请输入密码'},
                ],
            },
        }
    },
    methods:{
        doRegister() {
            const data = {
                ...this.form,
                phoneNum:this.form.phone,
                password: md5(this.form.password),
                username: this.form.nickname,
                smsCode:this.form.code
            }

            doRegister(data).then(res => {
                console.log(res)
                if(!res.success){
                    throw new Error(res.message)
                }
                localStorage.setItem('token',res.result)
                // 跳转到用户页
                this.$router.replace('/my')
            }).catch(err => {
                Toast.fail(err.message)
            })
        }
    }
}
</script>

<style scoped>

</style>
